import ApiBase from '../ApiBase';

class Exhibitor extends ApiBase {
    route = '/exhibitors/exhibitors';

    /**
     * @returns {Promise<*>}
     */
    getExhibitors = (search) => {
        return this.get(this.route, {
            search
        });
    };

    /**
     * @param id
     * @returns {Promise<*>}
     */
    getExhibitor = (id) => {
        return this.get(this.route + '/' + id);
    };

    /**
     * @method updateExhibitor
     * @param {string} id
     * @param {object} data
     * @return {Promise<*>}
     */
    updateExhibitor = async (id, data) => {
        return this.patch(this.route + '/' + id, data);
    }
}

export default new Exhibitor;
